module.exports = __webpack_public_path__ + "img/北京办公室2.2da72513.jpg";